// extracted by mini-css-extract-plugin
export default {"buttons_row":"download-links_buttons_row__wpCcM","button_link":"download-links_button_link__BRb-T"};